import { useMemo } from "react";

import { isEqual } from "lodash";
import { SplitPane } from "react-collapse-pane";

import Box from "@mui/material/Box";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const DEFAULT_SPLITER_SIZE = 50;
const COLLAPSED_SIZE = 8;
const SplitterContainer = ({ children, collapseDirection = 'down', ...other }) => {
  const splitterStyle = { background: "#EDEFF0", height: '10px' };

  /*
   * 접기 손잡이 = 바 위에 떠 있는 알약 버튼.
   *   아이콘만 넘기면 클릭 대상이 안 보여서(호버 피드백도 없어서) 껍데기를 하나 씌운다.
   *   ⚠ react-collapse-pane 이 이 요소를 자기 래퍼(styled-components 해시 클래스) 안에 꽂는다.
   *     그 클래스는 빌드마다 바뀌므로 선택자로 쓰면 안 되고, 모양·위치는 전부
   *     우리 `.splitter-button`(App.scss)에서 잡는다. 래퍼가 `position: relative` 라
   *     거기에 절대위치로 얹으면 바 한가운데에 정확히 걸린다.
   */
  const DownToggleButton = useMemo(() => {
    return <Box className="splitter-button"><KeyboardArrowDownIcon /></Box>;
  }, []);

  const UpToggleButton = useMemo(() => {
    return <Box className="splitter-button"><KeyboardArrowUpIcon /></Box>;
  }, []);

  return (
    <Box className="splitter-area">
      <SplitPane
        collapse={{
          beforeToggleButton: isEqual(collapseDirection, 'down') ? DownToggleButton : UpToggleButton,
          afterToggleButton: isEqual(collapseDirection, 'down') ? UpToggleButton : DownToggleButton,
          split: 'horizontal',
          collapsedSize: COLLAPSED_SIZE,
          overlayCss: { backgroundColor: "" },
          collapseTransitionTimeout: 350,
          buttonTransition: "none",
          collapseDirection,
        }}
        hooks={{
          onCollapse: (collapsed) => {
            for(let i = 0; i < collapsed.length; i++) {
              if(collapsed[i]) {
                collapsed[i] = collapsed[i] + (DEFAULT_SPLITER_SIZE - COLLAPSED_SIZE);
              }
            }
          }
        }}
        resizerOptions={{
          css: splitterStyle,
          hoverCss: splitterStyle
        }}
        collapseDirection={collapseDirection}
        initialSizes={[3, 2]}
        minSizes={[8, 8]}
        {...other}
      >
        {children}
      </SplitPane>
    </Box>
  );
};

export default SplitterContainer;